import React from "react";
import { motion } from "framer-motion";
import "./Hero.css";

export default function Hero() {
  const blobVariants = {
    one: {
      d: "M53.8,-61.9C67.9,-52.3,76.2,-33.6,78.2,-14.8C80.3,3.9,76.1,22.7,67.4,40C58.7,57.3,45.5,73.1,28.6,79.7C11.7,86.3,-8.9,83.7,-26.9,76.2C-44.9,68.7,-60.3,56.2,-67.6,40.5C-75,24.8,-74.3,5.9,-68.6,-9.6C-62.9,-25,-52.1,-37.1,-39.8,-47C-27.5,-57,-13.7,-64.9,3.1,-68.5C19.9,-72.1,39.7,-71.6,53.8,-61.9Z",
    },
    two: {
      d: "M51.5,-60.8C65.9,-49.3,76.2,-32.3,79.6,-13.8C83.1,4.6,79.9,24.4,70.5,40.9C61.2,57.4,45.9,70.6,29,74.4C12.2,78.2,-6.1,72.6,-25.2,66.7C-44.4,60.9,-64.3,54.8,-73.1,41.3C-81.9,27.9,-79.6,7.2,-75.5,-12.9C-71.5,-32.9,-65.7,-52.2,-52.9,-64C-40,-75.7,-20,-79.9,-0.7,-79C18.6,-78.2,37.1,-72.2,51.5,-60.8Z",
    },
    three: {
      d: "M53.3,-66.1C64.2,-54.4,64.8,-33,67.4,-12.7C69.9,7.5,74.3,26.5,68.5,42.4C62.7,58.3,46.6,71.1,27.9,78.9C9.1,86.7,-12.2,89.5,-26.9,81C-41.5,72.6,-49.4,52.8,-54.1,35.6C-58.9,18.4,-60.5,3.7,-59.4,-11.9C-58.4,-27.6,-54.7,-44.2,-44.4,-56C-34,-67.8,-17,-74.8,2.1,-77.3C21.2,-79.8,42.4,-77.8,53.3,-66.1Z",
    },
  };

  return (


    
    <div className="back-hero">
      
      <div className="backVideoDiv">
        <video className="backVideo" loop autoPlay muted playsinline="true" disablePictureInPicture="true">
          <source type="video/mp4" src="/loop_slowed.mp4"></source>
        </video>
      </div>

      <motion.div
        initial={{
          opacity: 1,
        }}
        animate={{
          opacity: 0,
        }}
        transition={{
          duration: 1,
          ease: "linear",
        }}
        className="blackLayer"
      ></motion.div>
      <motion.div className="hero-cont"
      
      initial={{
        position: "relative",
        right: "100px",
        bottom: "20px",
        opacity: 0
      }}
      animate={{
        right: "0px",
        bottom: "0px",
        opacity: 1
      }}
      transition={{
        duration: 0.5,
        ease:"backInOut"
      }}
      
      >
        <h1 className="hero-text heroHead">Hello</h1>
        <h1 className="hero-text heroHead">
          I'm <section className="name">Dheeraj</section>
        </h1>
        <h2 className="hero-text heroSubHead">Full Stack MERN Developer</h2>
        <h3 className="hero-text heroPara">
         With a solid foundation in both backend and frontend development, I bring a wealth of expertise to every project. Let's collaborate and bring innovative ideas to life!
        </h3>
        <div style={{gap: "45px", marginTop: "10px"}} className="socialIcons">
          <motion.svg
          onClick={()=>{
            window.open("https://github.com/dheeraj70", '_blank', 'noopener,noreferrer');
          }}
            style={{
                cursor: "pointer"
            }}
            whileHover={{
                scale: 1.2
            }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="40px"
            height="40px"
          >
            <path
              d="M32 6C17.641 6 6 17.641 6 32c0 12.277 8.512 22.56 19.955 25.286-.592-.141-1.179-.299-1.755-.479V50.85c0 0-.975.325-2.275.325-3.637 0-5.148-3.245-5.525-4.875-.229-.993-.827-1.934-1.469-2.509-.767-.684-1.126-.686-1.131-.92-.01-.491.658-.471.975-.471 1.625 0 2.857 1.729 3.429 2.623 1.417 2.207 2.938 2.577 3.721 2.577.975 0 1.817-.146 2.397-.426.268-1.888 1.108-3.57 2.478-4.774-6.097-1.219-10.4-4.716-10.4-10.4 0-2.928 1.175-5.619 3.133-7.792C19.333 23.641 19 22.494 19 20.625c0-1.235.086-2.751.65-4.225 0 0 3.708.026 7.205 3.338C28.469 19.268 30.196 19 32 19s3.531.268 5.145.738c3.497-3.312 7.205-3.338 7.205-3.338.567 1.474.65 2.99.65 4.225 0 2.015-.268 3.19-.432 3.697C46.466 26.475 47.6 29.124 47.6 32c0 5.684-4.303 9.181-10.4 10.4 1.628 1.43 2.6 3.513 2.6 5.85v8.557c-.576.181-1.162.338-1.755.479C49.488 54.56 58 44.277 58 32 58 17.641 46.359 6 32 6zM33.813 57.93C33.214 57.972 32.61 58 32 58 32.61 58 33.213 57.971 33.813 57.93zM37.786 57.346c-1.164.265-2.357.451-3.575.554C35.429 57.797 36.622 57.61 37.786 57.346zM32 58c-.61 0-1.214-.028-1.813-.07C30.787 57.971 31.39 58 32 58zM29.788 57.9c-1.217-.103-2.411-.289-3.574-.554C27.378 57.61 28.571 57.797 29.788 57.9z"
              fill="#eeeeee"
            />
          </motion.svg>
          <motion.svg
          onClick={()=>{
            window.open("https://www.linkedin.com/in/dheeraj70", '_blank', 'noopener,noreferrer');
          }}
            style={{
                cursor: "pointer"
            }}
            whileHover={{
                scale: 1.2
            }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            width="40px"
            height="40px"
          >
            <path
              d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"
              fill="#eeeeee"
            />
          </motion.svg>
          <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 2476 2476"
            id="instagram"
            onClick={()=>{
            window.open("https://www.instagram.com/dheeraj_kumar7717/", '_blank', 'noopener,noreferrer');
          }}
            style={{
                cursor: "pointer"
            }}
            whileHover={{
                scale: 1.2
            }}
          >
            <path
              d="M825.4 1238c0-227.9 184.7-412.7 412.6-412.7 227.9 0 412.7 184.8 412.7 412.7 0 227.9-184.8 412.7-412.7 412.7-227.9 0-412.6-184.8-412.6-412.7m-223.1 0c0 351.1 284.6 635.7 635.7 635.7s635.7-284.6 635.7-635.7-284.6-635.7-635.7-635.7S602.3 886.9 602.3 1238m1148-660.9c0 82 66.5 148.6 148.6 148.6 82 0 148.6-66.6 148.6-148.6s-66.5-148.5-148.6-148.5-148.6 66.5-148.6 148.5M737.8 2245.7c-120.7-5.5-186.3-25.6-229.9-42.6-57.8-22.5-99-49.3-142.4-92.6-43.3-43.3-70.2-84.5-92.6-142.3-17-43.6-37.1-109.2-42.6-229.9-6-130.5-7.2-169.7-7.2-500.3s1.3-369.7 7.2-500.3c5.5-120.7 25.7-186.2 42.6-229.9 22.5-57.8 49.3-99 92.6-142.4 43.3-43.3 84.5-70.2 142.4-92.6 43.6-17 109.2-37.1 229.9-42.6 130.5-6 169.7-7.2 500.2-7.2 330.6 0 369.7 1.3 500.3 7.2 120.7 5.5 186.2 25.7 229.9 42.6 57.8 22.4 99 49.3 142.4 92.6 43.3 43.3 70.1 84.6 92.6 142.4 17 43.6 37.1 109.2 42.6 229.9 6 130.6 7.2 169.7 7.2 500.3 0 330.5-1.2 369.7-7.2 500.3-5.5 120.7-25.7 186.3-42.6 229.9-22.5 57.8-49.3 99-92.6 142.3-43.3 43.3-84.6 70.1-142.4 92.6-43.6 17-109.2 37.1-229.9 42.6-130.5 6-169.7 7.2-500.3 7.2-330.5 0-369.7-1.2-500.2-7.2M727.6 7.5c-131.8 6-221.8 26.9-300.5 57.5-81.4 31.6-150.4 74-219.3 142.8C139 276.6 96.6 345.6 65 427.1 34.4 505.8 13.5 595.8 7.5 727.6 1.4 859.6 0 901.8 0 1238s1.4 378.4 7.5 510.4c6 131.8 26.9 221.8 57.5 300.5 31.6 81.4 73.9 150.5 142.8 219.3 68.8 68.8 137.8 111.1 219.3 142.8 78.8 30.6 168.7 51.5 300.5 57.5 132.1 6 174.2 7.5 510.4 7.5 336.3 0 378.4-1.4 510.4-7.5 131.8-6 221.8-26.9 300.5-57.5 81.4-31.7 150.4-74 219.3-142.8 68.8-68.8 111.1-137.9 142.8-219.3 30.6-78.7 51.6-168.7 57.5-300.5 6-132.1 7.4-174.2 7.4-510.4s-1.4-378.4-7.4-510.4c-6-131.8-26.9-221.8-57.5-300.5-31.7-81.4-74-150.4-142.8-219.3C2199.4 139 2130.3 96.6 2049 65c-78.8-30.6-168.8-51.6-300.5-57.5-132-6-174.2-7.5-510.4-7.5-336.3 0-378.4 1.4-510.5 7.5"
              fill="#eeeeee"
            />
          </motion.svg>
        </div>
      </motion.div>
      <motion.div className="heroimg"
      
      initial={{
        position: "relative",
        left: "100px",
        bottom: "20px",
        opacity: 0
      }}
      animate={{
        left: "0px",
        bottom: "0px",
        opacity: 1
      }}
      transition={{
        duration: 0.5,
        ease:"backInOut"
      }}
      >
        <svg
          className="heroSVG"
          viewBox="21 20 160 170"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid meet"
        >
          <defs>
  <pattern id="myself" patternUnits="objectBoundingBox" x="0" y="0" width="1" height="1">
    <image href="/myself.jpg" x="-25" y="-15" width="230" height="230" />
  </pattern>
</defs>
          <motion.path
            variants={blobVariants}
            
            animate={{
              d: ["M53.8,-61.9C67.9,-52.3,76.2,-33.6,78.2,-14.8C80.3,3.9,76.1,22.7,67.4,40C58.7,57.3,45.5,73.1,28.6,79.7C11.7,86.3,-8.9,83.7,-26.9,76.2C-44.9,68.7,-60.3,56.2,-67.6,40.5C-75,24.8,-74.3,5.9,-68.6,-9.6C-62.9,-25,-52.1,-37.1,-39.8,-47C-27.5,-57,-13.7,-64.9,3.1,-68.5C19.9,-72.1,39.7,-71.6,53.8,-61.9Z",
              "M51.5,-60.8C65.9,-49.3,76.2,-32.3,79.6,-13.8C83.1,4.6,79.9,24.4,70.5,40.9C61.2,57.4,45.9,70.6,29,74.4C12.2,78.2,-6.1,72.6,-25.2,66.7C-44.4,60.9,-64.3,54.8,-73.1,41.3C-81.9,27.9,-79.6,7.2,-75.5,-12.9C-71.5,-32.9,-65.7,-52.2,-52.9,-64C-40,-75.7,-20,-79.9,-0.7,-79C18.6,-78.2,37.1,-72.2,51.5,-60.8Z",
              "M51.1,-62.1C62.7,-51.1,66.2,-31.7,69.1,-12.6C72.1,6.6,74.4,25.5,67.4,40C60.3,54.6,43.8,64.9,25.5,72.6C7.2,80.3,-12.9,85.5,-30.5,80.5C-48.2,75.6,-63.4,60.5,-69.1,43.4C-74.8,26.3,-71,7.2,-67.9,-12.2C-64.8,-31.7,-62.3,-51.5,-51.1,-62.6C-39.9,-73.7,-20,-76.1,-0.1,-76C19.7,-75.8,39.4,-73.2,51.1,-62.1Z",
              "M53.8,-61.9C67.9,-52.3,76.2,-33.6,78.2,-14.8C80.3,3.9,76.1,22.7,67.4,40C58.7,57.3,45.5,73.1,28.6,79.7C11.7,86.3,-8.9,83.7,-26.9,76.2C-44.9,68.7,-60.3,56.2,-67.6,40.5C-75,24.8,-74.3,5.9,-68.6,-9.6C-62.9,-25,-52.1,-37.1,-39.8,-47C-27.5,-57,-13.7,-64.9,3.1,-68.5C19.9,-72.1,39.7,-71.6,53.8,-61.9Z"
            ]
            }}
            transition={{
              yoyo: Infinity,
              duration: 5,
              repeat: Infinity,
              times: [0, 0.33, 0.66, 1],
              ease: "linear"
            }}
            fill="url(#myself)"
            stroke="#eeeeee" stroke-width="1.5"
            transform="translate(100 100)"
          />
        </svg>
      </motion.div>
    </div>
  );
}
